import {Injectable, Injector} from '@angular/core';
import {LogPublisher, LogConsole, LogLocalStorage, LogWebApi} from './log-publishers';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class LogPublishersService {
  publishers: LogPublisher[] = [];
  private http: HttpClient;

  constructor(private injector: Injector) {
    // Build publishers arrays
    this.buildPublishers();
  }


  buildPublishers(): void {
    // TODO: consider loading these from API
    this.publishers.push(new LogConsole());
    // this.publishers.push(new LogLocalStorage());
    if (!this.http) {
        this.http = this.injector.get(HttpClient);
    }
    this.publishers.push(new LogWebApi(this.http));
  }
}
